<template>
    
</template>

<script>
    export default {
        name: "Wp_mini_event"
    }
</script>

<style scoped>

</style>